import { Formatting } from "../utils/format";
import { Config } from "../config/store";
export default new Formatting(Config);
